/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState } from 'react';
import { Form, Placeholder } from 'react-bootstrap';
import { useTheme } from '@/providers/theme';
import * as S from './styles';

export interface ITextInputProps {
  id: string;
  type: 'text' | 'email';
  label?: string;
  invalidText?: string;
  required?: boolean;
  placeholder?: string;
  value?: string;
  onCompChange?(item: any, id: string, payload: any): void;
  [key: string]: any;
}

export const TextInput = (props: ITextInputProps) => {
  const {
    label,
    invalidText,
    onCompChange,
    value,
    required,
    type,
    placeholder,
    item,
  } = props;
  const theme = useTheme();
  const [textValue, setTextValue] = useState(value ?? '');
  const onChange = (id: string, e: any) => {
    setTextValue(e?.target?.value);
    onCompChange && onCompChange(item, id, e?.target?.value);
  };

  return (
    <Form.Group className="formgroup">
      {label && (
        <S.FormLabel color={theme?.colors?.primary}>
          {label}
          {required && <sup style={{ color: 'red' }}>*</sup>}
        </S.FormLabel>
      )}
      <Form.Control
        className="formcontrol shadow-none"
        type={type}
        placeholder={placeholder}
        onChange={onChange.bind(null, props?.id)}
        defaultValue={value}
      />
      <S.FeedbackLabel type="invalid">{invalidText}</S.FeedbackLabel>
    </Form.Group>
  );
};

TextInput.defaultProps = {};
